<template>

<com-logic>

    <com-input :type="type" :rule="rule" v-model="model.value" />

    <div class="logic-text"><i class="fa-sharp fa-plus-minus" /></div>

    <com-input :type="type" :rule="rule" v-model="model.tolerance" />

</com-logic>

</template>

<script>

import mixLogic from './logic'

export default {

    mixins: [mixLogic],

    data: function() {

        return {
            noOperand: true,
            model: {
                operand: '=',
                value: '',
                tolerance: ''
            }
        }

    }

}

</script>

<style scoped>

</style>